"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = __importDefault(require("classnames"));
var React = __importStar(require("react"));
var Faq = /** @class */ (function (_super) {
    __extends(Faq, _super);
    function Faq() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            open: false,
        };
        _this.toggle = function () {
            _this.setState({ open: !_this.state.open });
        };
        return _this;
    }
    Faq.prototype.render = function () {
        return (React.createElement("div", { className: 'faq-container padding-vertical-3' },
            React.createElement("div", { className: 'grid-x' },
                React.createElement("div", { className: 'cell small-11' },
                    React.createElement("a", { className: 'font-bold text-uppercase', onClick: this.toggle }, this.props.question),
                    React.createElement("div", { dangerouslySetInnerHTML: { __html: this.props.answer }, className: (0, classnames_1.default)('faq-answer padding-top-3', this.state.open ? 'shown' : '') })),
                React.createElement("div", { className: (0, classnames_1.default)('cell small-1 font-bold') },
                    React.createElement("div", { className: (0, classnames_1.default)('font-bold faq-icon', this.state.open ? 'open' : ''), onClick: this.toggle }, "+")))));
    };
    return Faq;
}(React.Component));
exports.default = Faq;
